"use strict";

var _slicedToArray = require("/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isReady = isReady;
exports.waitReady = waitReady;
exports.twox = exports.sha512 = exports.scrypt = exports.pbkdf2 = exports.keccak256 = exports.blake2b = exports.vrfVerify = exports.vrfSign = exports.sr25519Verify = exports.sr25519Sign = exports.sr25519KeypairFromSeed = exports.sr25519DerivePublicSoft = exports.sr25519DeriveKeypairSoft = exports.sr25519DeriveKeypairHard = exports.ed25519Verify = exports.ed25519Sign = exports.ed25519KeypairFromSeed = exports.bip39Validate = exports.bip39ToSeed = exports.bip39ToMiniSecret = exports.bip39ToEntropy = exports.bip39Generate = void 0;

require("./detectPackage");

var _wasmCryptoAsmjs = require("@polkadot/wasm-crypto-asmjs");

var _wasmCryptoWasm = require("@polkadot/wasm-crypto-wasm");

var _bridge = require("./bridge");

var imports = _interopRequireWildcard(require("./imports")); // Copyright 2019-2021 @polkadot/wasm-crypto authors & contributors
// SPDX-License-Identifier: Apache-2.0


var wasmPromise = (0, _bridge.initWasm)(_wasmCryptoWasm.wasmBytes, _wasmCryptoAsmjs.asmJsInit, imports).catch(function () {
  return null;
});
var bip39Generate = (0, _bridge.withWasm)(function (wasm) {
  return function (words) {
    wasm.ext_bip39_generate(8, words);
    return (0, _bridge.resultString)();
  };
});
exports.bip39Generate = bip39Generate;
var bip39ToEntropy = (0, _bridge.withWasm)(function (wasm) {
  return function (phrase) {
    var _ref = (0, _bridge.allocString)(phrase),
        _ref2 = _slicedToArray(_ref, 2),
        ptr0 = _ref2[0],
        len0 = _ref2[1];

    wasm.ext_bip39_to_entropy(8, ptr0, len0);
    return (0, _bridge.resultU8a)();
  };
});
exports.bip39ToEntropy = bip39ToEntropy;
var bip39ToMiniSecret = (0, _bridge.withWasm)(function (wasm) {
  return function (phrase, password) {
    var _ref3 = (0, _bridge.allocString)(phrase),
        _ref4 = _slicedToArray(_ref3, 2),
        ptr0 = _ref4[0],
        len0 = _ref4[1];

    var _ref5 = (0, _bridge.allocString)(password),
        _ref6 = _slicedToArray(_ref5, 2),
        ptr1 = _ref6[0],
        len1 = _ref6[1];

    wasm.ext_bip39_to_mini_secret(8, ptr0, len0, ptr1, len1);
    return (0, _bridge.resultU8a)();
  };
});
exports.bip39ToMiniSecret = bip39ToMiniSecret;
var bip39ToSeed = (0, _bridge.withWasm)(function (wasm) {
  return function (phrase, password) {
    var _ref7 = (0, _bridge.allocString)(phrase),
        _ref8 = _slicedToArray(_ref7, 2),
        ptr0 = _ref8[0],
        len0 = _ref8[1];

    var _ref9 = (0, _bridge.allocString)(password),
        _ref10 = _slicedToArray(_ref9, 2),
        ptr1 = _ref10[0],
        len1 = _ref10[1];

    wasm.ext_bip39_to_seed(8, ptr0, len0, ptr1, len1);
    return (0, _bridge.resultU8a)();
  };
});
exports.bip39ToSeed = bip39ToSeed;
var bip39Validate = (0, _bridge.withWasm)(function (wasm) {
  return function (phrase) {
    var _ref11 = (0, _bridge.allocString)(phrase),
        _ref12 = _slicedToArray(_ref11, 2),
        ptr0 = _ref12[0],
        len0 = _ref12[1];

    var ret = wasm.ext_bip39_validate(ptr0, len0);
    return ret !== 0;
  };
});
exports.bip39Validate = bip39Validate;
var ed25519KeypairFromSeed = (0, _bridge.withWasm)(function (wasm) {
  return function (seed) {
    var _ref13 = (0, _bridge.allocU8a)(seed),
        _ref14 = _slicedToArray(_ref13, 2),
        ptr0 = _ref14[0],
        len0 = _ref14[1];

    wasm.ext_ed_from_seed(8, ptr0, len0);
    return (0, _bridge.resultU8a)();
  };
});
exports.ed25519KeypairFromSeed = ed25519KeypairFromSeed;
var ed25519Sign = (0, _bridge.withWasm)(function (wasm) {
  return function (pubkey, seckey, message) {
    var _ref15 = (0, _bridge.allocU8a)(pubkey),
        _ref16 = _slicedToArray(_ref15, 2),
        ptr0 = _ref16[0],
        len0 = _ref16[1];

    var _ref17 = (0, _bridge.allocU8a)(seckey),
        _ref18 = _slicedToArray(_ref17, 2),
        ptr1 = _ref18[0],
        len1 = _ref18[1];

    var _ref19 = (0, _bridge.allocU8a)(message),
        _ref20 = _slicedToArray(_ref19, 2),
        ptr2 = _ref20[0],
        len2 = _ref20[1];

    wasm.ext_ed_sign(8, ptr0, len0, ptr1, len1, ptr2, len2);
    return (0, _bridge.resultU8a)();
  };
});
exports.ed25519Sign = ed25519Sign;
var ed25519Verify = (0, _bridge.withWasm)(function (wasm) {
  return function (signature, message, pubkey) {
    var _ref21 = (0, _bridge.allocU8a)(signature),
        _ref22 = _slicedToArray(_ref21, 2),
        ptr0 = _ref22[0],
        len0 = _ref22[1];

    var _ref23 = (0, _bridge.allocU8a)(message),
        _ref24 = _slicedToArray(_ref23, 2),
        ptr1 = _ref24[0],
        len1 = _ref24[1];

    var _ref25 = (0, _bridge.allocU8a)(pubkey),
        _ref26 = _slicedToArray(_ref25, 2),
        ptr2 = _ref26[0],
        len2 = _ref26[1];

    var ret = wasm.ext_ed_verify(ptr0, len0, ptr1, len1, ptr2, len2);
    return ret !== 0;
  };
});
exports.ed25519Verify = ed25519Verify;
var sr25519DeriveKeypairHard = (0, _bridge.withWasm)(function (wasm) {
  return function (pair, cc) {
    var _ref27 = (0, _bridge.allocU8a)(pair),
        _ref28 = _slicedToArray(_ref27, 2),
        ptr0 = _ref28[0],
        len0 = _ref28[1];

    var _ref29 = (0, _bridge.allocU8a)(cc),
        _ref30 = _slicedToArray(_ref29, 2),
        ptr1 = _ref30[0],
        len1 = _ref30[1];

    wasm.ext_sr_derive_keypair_hard(8, ptr0, len0, ptr1, len1);
    return (0, _bridge.resultU8a)();
  };
});
exports.sr25519DeriveKeypairHard = sr25519DeriveKeypairHard;
var sr25519DeriveKeypairSoft = (0, _bridge.withWasm)(function (wasm) {
  return function (pair, cc) {
    var _ref31 = (0, _bridge.allocU8a)(pair),
        _ref32 = _slicedToArray(_ref31, 2),
        ptr0 = _ref32[0],
        len0 = _ref32[1];

    var _ref33 = (0, _bridge.allocU8a)(cc),
        _ref34 = _slicedToArray(_ref33, 2),
        ptr1 = _ref34[0],
        len1 = _ref34[1];

    wasm.ext_sr_derive_keypair_soft(8, ptr0, len0, ptr1, len1);
    return (0, _bridge.resultU8a)();
  };
});
exports.sr25519DeriveKeypairSoft = sr25519DeriveKeypairSoft;
var sr25519DerivePublicSoft = (0, _bridge.withWasm)(function (wasm) {
  return function (pubkey, cc) {
    var _ref35 = (0, _bridge.allocU8a)(pubkey),
        _ref36 = _slicedToArray(_ref35, 2),
        ptr0 = _ref36[0],
        len0 = _ref36[1];

    var _ref37 = (0, _bridge.allocU8a)(cc),
        _ref38 = _slicedToArray(_ref37, 2),
        ptr1 = _ref38[0],
        len1 = _ref38[1];

    wasm.ext_sr_derive_public_soft(8, ptr0, len0, ptr1, len1);
    return (0, _bridge.resultU8a)();
  };
});
exports.sr25519DerivePublicSoft = sr25519DerivePublicSoft;
var sr25519KeypairFromSeed = (0, _bridge.withWasm)(function (wasm) {
  return function (seed) {
    var _ref39 = (0, _bridge.allocU8a)(seed),
        _ref40 = _slicedToArray(_ref39, 2),
        ptr0 = _ref40[0],
        len0 = _ref40[1];

    wasm.ext_sr_from_seed(8, ptr0, len0);
    return (0, _bridge.resultU8a)();
  };
});
exports.sr25519KeypairFromSeed = sr25519KeypairFromSeed;
var sr25519Sign = (0, _bridge.withWasm)(function (wasm) {
  return function (pubkey, secret, message) {
    var _ref41 = (0, _bridge.allocU8a)(pubkey),
        _ref42 = _slicedToArray(_ref41, 2),
        ptr0 = _ref42[0],
        len0 = _ref42[1];

    var _ref43 = (0, _bridge.allocU8a)(secret),
        _ref44 = _slicedToArray(_ref43, 2),
        ptr1 = _ref44[0],
        len1 = _ref44[1];

    var _ref45 = (0, _bridge.allocU8a)(message),
        _ref46 = _slicedToArray(_ref45, 2),
        ptr2 = _ref46[0],
        len2 = _ref46[1];

    wasm.ext_sr_sign(8, ptr0, len0, ptr1, len1, ptr2, len2);
    return (0, _bridge.resultU8a)();
  };
});
exports.sr25519Sign = sr25519Sign;
var sr25519Verify = (0, _bridge.withWasm)(function (wasm) {
  return function (signature, message, pubkey) {
    var _ref47 = (0, _bridge.allocU8a)(signature),
        _ref48 = _slicedToArray(_ref47, 2),
        ptr0 = _ref48[0],
        len0 = _ref48[1];

    var _ref49 = (0, _bridge.allocU8a)(message),
        _ref50 = _slicedToArray(_ref49, 2),
        ptr1 = _ref50[0],
        len1 = _ref50[1];

    var _ref51 = (0, _bridge.allocU8a)(pubkey),
        _ref52 = _slicedToArray(_ref51, 2),
        ptr2 = _ref52[0],
        len2 = _ref52[1];

    var ret = wasm.ext_sr_verify(ptr0, len0, ptr1, len1, ptr2, len2);
    return ret !== 0;
  };
});
exports.sr25519Verify = sr25519Verify;
var vrfSign = (0, _bridge.withWasm)(function (wasm) {
  return function (secret, context, message, extra) {
    var _ref53 = (0, _bridge.allocU8a)(secret),
        _ref54 = _slicedToArray(_ref53, 2),
        ptr0 = _ref54[0],
        len0 = _ref54[1];

    var _ref55 = (0, _bridge.allocU8a)(context),
        _ref56 = _slicedToArray(_ref55, 2),
        ptr1 = _ref56[0],
        len1 = _ref56[1];

    var _ref57 = (0, _bridge.allocU8a)(message),
        _ref58 = _slicedToArray(_ref57, 2),
        ptr2 = _ref58[0],
        len2 = _ref58[1];

    var _ref59 = (0, _bridge.allocU8a)(extra),
        _ref60 = _slicedToArray(_ref59, 2),
        ptr3 = _ref60[0],
        len3 = _ref60[1];

    wasm.ext_vrf_sign(8, ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3);
    return (0, _bridge.resultU8a)();
  };
});
exports.vrfSign = vrfSign;
var vrfVerify = (0, _bridge.withWasm)(function (wasm) {
  return function (pubkey, context, message, extra, outAndProof) {
    var _ref61 = (0, _bridge.allocU8a)(pubkey),
        _ref62 = _slicedToArray(_ref61, 2),
        ptr0 = _ref62[0],
        len0 = _ref62[1];

    var _ref63 = (0, _bridge.allocU8a)(context),
        _ref64 = _slicedToArray(_ref63, 2),
        ptr1 = _ref64[0],
        len1 = _ref64[1];

    var _ref65 = (0, _bridge.allocU8a)(message),
        _ref66 = _slicedToArray(_ref65, 2),
        ptr2 = _ref66[0],
        len2 = _ref66[1];

    var _ref67 = (0, _bridge.allocU8a)(extra),
        _ref68 = _slicedToArray(_ref67, 2),
        ptr3 = _ref68[0],
        len3 = _ref68[1];

    var _ref69 = (0, _bridge.allocU8a)(outAndProof),
        _ref70 = _slicedToArray(_ref69, 2),
        ptr4 = _ref70[0],
        len4 = _ref70[1];

    var ret = wasm.ext_vrf_verify(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4);
    return ret !== 0;
  };
});
exports.vrfVerify = vrfVerify;
var blake2b = (0, _bridge.withWasm)(function (wasm) {
  return function (data, key, size) {
    var _ref71 = (0, _bridge.allocU8a)(data),
        _ref72 = _slicedToArray(_ref71, 2),
        ptr0 = _ref72[0],
        len0 = _ref72[1];

    var _ref73 = (0, _bridge.allocU8a)(key),
        _ref74 = _slicedToArray(_ref73, 2),
        ptr1 = _ref74[0],
        len1 = _ref74[1];

    wasm.ext_blake2b(8, ptr0, len0, ptr1, len1, size);
    return (0, _bridge.resultU8a)();
  };
});
exports.blake2b = blake2b;
var keccak256 = (0, _bridge.withWasm)(function (wasm) {
  return function (data) {
    var _ref75 = (0, _bridge.allocU8a)(data),
        _ref76 = _slicedToArray(_ref75, 2),
        ptr0 = _ref76[0],
        len0 = _ref76[1];

    wasm.ext_keccak256(8, ptr0, len0);
    return (0, _bridge.resultU8a)();
  };
});
exports.keccak256 = keccak256;
var pbkdf2 = (0, _bridge.withWasm)(function (wasm) {
  return function (data, salt, rounds) {
    var _ref77 = (0, _bridge.allocU8a)(data),
        _ref78 = _slicedToArray(_ref77, 2),
        ptr0 = _ref78[0],
        len0 = _ref78[1];

    var _ref79 = (0, _bridge.allocU8a)(salt),
        _ref80 = _slicedToArray(_ref79, 2),
        ptr1 = _ref80[0],
        len1 = _ref80[1];

    wasm.ext_pbkdf2(8, ptr0, len0, ptr1, len1, rounds);
    return (0, _bridge.resultU8a)();
  };
});
exports.pbkdf2 = pbkdf2;
var scrypt = (0, _bridge.withWasm)(function (wasm) {
  return function (password, salt, log2n, r, p) {
    var _ref81 = (0, _bridge.allocU8a)(password),
        _ref82 = _slicedToArray(_ref81, 2),
        ptr0 = _ref82[0],
        len0 = _ref82[1];

    var _ref83 = (0, _bridge.allocU8a)(salt),
        _ref84 = _slicedToArray(_ref83, 2),
        ptr1 = _ref84[0],
        len1 = _ref84[1];

    wasm.ext_scrypt(8, ptr0, len0, ptr1, len1, log2n, r, p);
    return (0, _bridge.resultU8a)();
  };
});
exports.scrypt = scrypt;
var sha512 = (0, _bridge.withWasm)(function (wasm) {
  return function (data) {
    var _ref85 = (0, _bridge.allocU8a)(data),
        _ref86 = _slicedToArray(_ref85, 2),
        ptr0 = _ref86[0],
        len0 = _ref86[1];

    wasm.ext_sha512(8, ptr0, len0);
    return (0, _bridge.resultU8a)();
  };
});
exports.sha512 = sha512;
var twox = (0, _bridge.withWasm)(function (wasm) {
  return function (data, rounds) {
    var _ref87 = (0, _bridge.allocU8a)(data),
        _ref88 = _slicedToArray(_ref87, 2),
        ptr0 = _ref88[0],
        len0 = _ref88[1];

    wasm.ext_twox(8, ptr0, len0, rounds);
    return (0, _bridge.resultU8a)();
  };
});
exports.twox = twox;

function isReady() {
  return !!(0, _bridge.getWasm)();
}

function waitReady() {
  return wasmPromise.then(function () {
    return isReady();
  });
}